import { useRef, useCallback, useEffect } from 'react'
import { BET_CONFIG } from 'src/config'

export function useBonusDisplay() {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const clearHideTimeout = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
  }, [])

  const startAutoHideTimer = useCallback((hideCallback: () => void) => {
    clearHideTimeout()
    timeoutRef.current = setTimeout(() => {
      hideCallback()
      timeoutRef.current = null
    }, BET_CONFIG.BONUS_DISPLAY_HIDE_DELAY_MS)
  }, [clearHideTimeout])

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      clearHideTimeout()
    }
  }, [clearHideTimeout])

  return {
    startAutoHideTimer,
    clearHideTimeout
  }
}